import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./mobileapp.css";
import HEROIMG from "../../../image/mobileapp/hero-imgNew.webp";
import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useState } from "react";
import { useEffect } from "react";

const MobileApp = () => {
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);

  const [isContentChange, setIsContentChange] = useState(true);
  const [isAndroidChange, setIsAndroidChange] = useState(true);
  const [isPWAChange, setIsPWAChange] = useState(true);
  const [activeLink, setActiveLink] = useState("ios");

  const handleSlideChange = (swiper) => {
    setIsPrevDisabled(swiper.isBeginning);
    setIsNextDisabled(swiper.isEnd);
  };

  const handleChooseChange = (chooseSwiper) => {
    setIsPrevChooseDisabled(chooseSwiper.isBeginning);
    setIsNextChooseDisabled(chooseSwiper.isEnd);
  };

  const handleContentChange = () => {
    setIsContentChange(!isContentChange);
  };

  const handleAndroidChange = () => {
    setIsAndroidChange(!isAndroidChange);
  };

  const handlePWAcHANGE = () => {
    setIsPWAChange(!isPWAChange);
  };

  const handleTypes = (path) => {
    setActiveLink(path);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Mobile App Development Company</title>

        <meta name="title" content="Mobile App Development Company" />
        <meta
          name="description"
          content="Looking for a reliable mobile app development company? We specialize in custom iOS, Android, and PWA solutions to bring your app ideas to life. Boost engagement and grow your business with cutting-edge mobile app development!"
        />

        <meta property="og:title" content="Mobile App Development Company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/mobile-app-development-company"
        />
      </Helmet>

      <main className="mobile-app-bg">
        <div className="blue-grad"></div>
        {/* hero */}
        <div className="mobile-app-section">
          <article className="primary__landing-content-container">
            <div className="mobile-app-hero">
              <div className="row mobile-hero-row">
                <div className="col-lg-6">
                  <div>
                    <h1 className="mobile-hero-title">
                      Mobile App{" "}
                      <span className="mobile-gradient"> Development</span>{" "}
                      Company
                      <img
                        src={require("../../../image/mobileapp/star-icon.webp")}
                        alt="Mobile App Development Company"
                        loading="lazy"
                        className="mobile-star"
                      />
                    </h1>
                    <p className="mobile-hero-content">
                      Beleaf technologies a mobile app development company
                      ensures that your ideas transform into functional and
                      visually stunning mobile solutions.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="mobile-app-btn"
                    >
                      Get Consultation{" "}
                      <span className="mobile-btn-arr">
                        <i className="fa-solid fa-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mobile-hero-right mobile-hero-rightNew">
                    <img
                      src={HEROIMG}
                      alt="Mobile App Development Company"
                      loading="lazy"
                      className="mob_app_imge"
                    />
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>

        {/* about */}
        <article className="primary__landing-content-container ">
          <h2 className="mobile-sub-titles mobile-about-title">
            What is a <span className="mobile-gradient">Mobile App</span>{" "}
            Development Company?
          </h2>

          <div className="row mobile-about-row">
            <div className="col-lg-6">
              <img
                src={require("../../../image/mobileapp/about-imgNew.webp")}
                alt="Mobile App Development Company"
                loading="lazy"
                className="mobile-about-img mobile-about-imgNew"
              />
            </div>
            <div className="col-lg-6">
              <div>
                <ul className="mobile-lists">
                  <li className="mobile-list-content">
                    A mobile app development company plays a crucial role in
                    helping businesses build innovative apps to engage their
                    users effectively.
                  </li>
                  <li className="mobile-list-content">
                    Whether you want to develop an app for iOS, Android, or
                    create a Progressive Web App (PWA), a skilled mobile app
                    development company can bring your vision to life.
                  </li>
                  <li className="mobile-list-content">
                    This article explains the services provided by a mobile app
                    development company, focusing on iOS app development,
                    Android app development, and PWA development.
                  </li>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="mobile-app-btn"
                  >
                    Get Demo
                    <span className="mobile-btn-arr">
                      <i className="fa-solid fa-chevron-right"></i>
                    </span>
                  </button>
                </ul>
              </div>
            </div>
          </div>
        </article>

        {/* Types */}
        <article className="primary__landing-content-container ">
          <div className="row mobile-types-row">
            <div className="col-lg-6">
              <h2 className="mobile-sub-titles">
                <span className="mobile-gradient">Types of</span> Mobile App
                Development
              </h2>
              <p className="mobile-types-content">
                Different types of mobile app development cater to diverse
                business needs and target audiences. A versatile mobile app
                development company provides services in
              </p>

              <div className="icons-btns">
                <div
                  className={`icons-flex-wrap ${
                    activeLink === "ios" ? "active-link ios" : ""
                  }`}
                  onClick={() => handleTypes("ios")}
                >
                  <div className="icons-flex-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/apple-icon.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <p>IOS App Development</p>
                  <span>
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                </div>
                <div
                  className={`icons-flex-wrap ${
                    activeLink === "playstore" ? "active-link play" : ""
                  }`}
                  onClick={() => handleTypes("playstore")}
                >
                  <div className="icons-flex-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/android-icon.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <p>Android App Development</p>
                  <span>
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                </div>
                <div
                  className={`icons-flex-wrap ${
                    activeLink === "pwa" ? "active-link pwa" : ""
                  }`}
                  onClick={() => handleTypes("pwa")}
                >
                  <div className="icons-flex-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/pwa-icon.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <p>Progressive Web App Development (PWA)</p>
                  <span>
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-6 types-right-col">
              <div className="mobile-types-box">
                <div className="mobile-types-inner">
                  <div
                    className={`mob-inner-boxes mob-apple ${
                      activeLink === "ios"
                        ? "active-link01"
                        : activeLink === "playstore"
                        ? "active-link03"
                        : "active-link03"
                    }`}
                  >
                    <div className="types-flex">
                      <div>
                        <img
                          src={require("../../../image/mobileapp/ios-icon.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="types-img"
                        />
                      </div>
                      <div>
                        <p className="types-title">Avaliable on the</p>
                        <h6 className="types-content">APP STORE</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`mob-inner-boxes mob-playstore ${
                      activeLink === "ios"
                        ? "active-link02"
                        : activeLink === "playstore"
                        ? "active-link01"
                        : "active-link02"
                    }`}
                  >
                    <div className="types-flex">
                      <div>
                        <img
                          src={require("../../../image/mobileapp/playstore.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="types-img"
                        />
                      </div>
                      <div>
                        <p className="types-title">Avaliable on the</p>
                        <h6 className="types-content">GOOGLE PLAY</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`mob-inner-boxes mob-pwa ${
                      activeLink === "ios"
                        ? "active-link03"
                        : activeLink === "playstore"
                        ? "active-link03"
                        : "active-link01"
                    }`}
                  >
                    <div className="types-flex">
                      <div>
                        <img
                          src={require("../../../image/mobileapp/pwa.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="types-img"
                        />
                      </div>
                      <div>
                        <p className="types-title">Launch as</p>
                        <h6 className="types-content">WEB APP</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* IOS */}
        <article className="ios-section">
          <div>
            <Swiper
              className="mob-app-swiper"
              spaceBetween={30}
              slidesPerView={1}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".mob-prev-arrow",
                nextEl: ".mob-next-arrow",
              }}
              onSlideChange={handleSlideChange}
              onReachBeginning={() => setIsPrevDisabled(true)}
              onReachEnd={() => setIsNextDisabled(true)}
              onFromEdge={() => {
                setIsPrevDisabled(false);
                setIsNextDisabled(false);
              }}
            >
              <SwiperSlide>
                <div>
                  <h2 className="mobile-sub-titles ios-title">
                    iOS App Development Empowering
                    <span className="mobile-gradient ">
                      {" "}
                      Apple Ecosystem
                    </span>{" "}
                    Users
                  </h2>
                  <p className="mobile-types-content ios-content">
                    iOS app development focuses on creating applications for
                    Apple devices such as iPhones, iPads, Apple Watches, and
                    Apple TVs. The operating system's robust security, intuitive
                    interface, and loyal user base make iOS apps a popular
                    choice for businesses aiming to deliver a premium
                    experience.
                  </p>

                  {/* hide at mobile view */}
                  <h4 className="ios-key">
                    {isContentChange
                      ? "Key Features of iOS App Development"
                      : "Benefits of iOS App Development for Businesses"}
                  </h4>
                  <div className="mob-features">
                    <div className="container">
                      <div className="row mob-slide-row">
                        <div className="col-sm-4 mob-one">
                          <div>
                            <h6 className="mob-slider-title text-right">
                              {isContentChange
                                ? "Performance Optimization"
                                : "Global Reach"}
                            </h6>
                            {isContentChange ? (
                              <p className="mob-slider-content text-right">
                                Apps are designed for{" "}
                                <div>
                                  seamless performance on Apple devices.
                                </div>
                              </p>
                            ) : (
                              <p className="mob-slider-content text-right">
                                IOS apps tap into Apple’s
                                <div>high-income user base.</div>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-4 mob-two">
                          <div>
                            <h6 className="mob-slider-title text-left">
                              {isContentChange
                                ? "High Security"
                                : "App Monetization"}
                            </h6>
                            {isContentChange ? (
                              <p className="mob-slider-content text-left">
                                iOS apps are built with stringent
                                <div>security features to protect user</div>
                                data.
                              </p>
                            ) : (
                              <p className="mob-slider-content text-left">
                                iOS users are more likely to make
                                <div>in-app purchases, boosting</div>
                                revenue opportunities.
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container mt-5">
                      <div className="row mob-slide-row">
                        <div className="col-sm-4 mob-three">
                          <div>
                            <h6 className="mob-slider-title text-right">
                              {isContentChange
                                ? "Aesthetic Design"
                                : "Brand Credibility"}
                            </h6>

                            {isContentChange ? (
                              <p className="mob-slider-content text-right">
                                The user interface (UI) aligns with
                                <div>
                                  {" "}
                                  Apple's minimalist and sophisticated{" "}
                                </div>
                                design principles.
                              </p>
                            ) : (
                              <p className="mob-slider-content text-right">
                                iOS users associate apps on the App
                                <div> Store with reliability and quality.</div>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-4 mob-four">
                          <div>
                            {isContentChange ? (
                              <h6 className="mob-slider-title text-left">
                                Integration with <div>Apple Ecosystem</div>
                              </h6>
                            ) : (
                              ""
                            )}
                            {/* <h6 className="mob-slider-title text-left">
                              {isContentChange
                                ? "Integration with  Apple Ecosystem"
                                : ""}
                            </h6> */}
                            {isContentChange ? (
                              <p className="mob-slider-content text-left">
                                iOS apps work flawlessly with{" "}
                                <div> other Apple products like iCloud, </div>{" "}
                                Siri, and HomeKit.
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      {isContentChange ? (
                        <img
                          src={require("../../../image/mobileapp/featuresNew.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="mob-bg featuresNewImg"
                          onClick={handleContentChange}
                        />
                      ) : (
                        <img
                          src={require("../../../image/mobileapp/features-twoNew.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="mob-bg"
                          onClick={handleContentChange}
                        />
                      )}
                    </div>
                  </div>

                  {/* visible at mobile view */}
                  <div className="primary__landing-content-container mob-features-card">
                    {/* key features */}
                    <div>
                      <h4 className="mob_feature-card-title">
                        Key Features of iOS App Development
                      </h4>
                      <div className="mob-flex">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Performance Optimization
                              </h6>
                              <p className="mob-inner-slider-content">
                                Apps are designed for seamless performance on
                                Apple devices.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                High Security
                              </h6>
                              <p className="mob-inner-slider-content">
                                iOS apps are built with stringent security
                                features to protect user data.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mob-flex mob-flex-mt">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Aesthetic Design
                              </h6>
                              <p className="mob-inner-slider-content">
                                The user interface (UI) aligns with Apple's
                                minimalist and sophisticated design principles.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Integration with Apple Ecosystem
                              </h6>
                              <p className="mob-inner-slider-content">
                                iOS apps work flawlessly with other Apple
                                products like iCloud, Siri, and HomeKit.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* benefits */}
                    <div className="mt-5 pb-5">
                      <h4 className="mob_feature-card-title">
                        Benefits of iOS App Development for Businesses
                      </h4>
                      <div className="mob-flex">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Global Reach
                              </h6>
                              <p className="mob-inner-slider-content">
                                IOS apps tap into Apple’s high-income user base.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                App Monetization
                              </h6>
                              <p className="mob-inner-slider-content">
                                iOS users are more likely to make in-app
                                purchases, boosting revenue opportunities.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mob-flex mob-flex-mt">
                        <div className="w-100">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Brand Credibility
                              </h6>
                              <p className="mob-inner-slider-content">
                                iOS users associate apps on the App Store with
                                reliability and quality.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div>
                  <h2 className="mobile-sub-titles ios-title">
                    <span className="mobile-gradient "> Android App</span>{" "}
                    Development
                  </h2>
                  <p className="mobile-types-content android-content">
                    Android app development targets the world’s most popular
                    mobile operating system. With its extensive user base and
                    compatibility across diverse devices, Android offers
                    unparalleled opportunities for businesses.
                  </p>

                  {/* hide at mobile view */}
                  <h4 className="ios-key">
                    {isAndroidChange
                      ? "Key Features of Android App Development"
                      : "Benefits of Android App Development for Businesses"}
                  </h4>
                  <div className="mob-features">
                    <div className="container">
                      <div className="row mob-slide-row">
                        <div className="col-sm-4 mob-one">
                          <div>
                            <h6 className="mob-slider-title text-right">
                              {isAndroidChange
                                ? "Customizable Interface"
                                : "Larger Audience"}
                            </h6>
                            {isAndroidChange ? (
                              <p className="mob-slider-content text-right">
                                Android apps allow greater{" "}
                                <div>flexibility in UI/UX design.</div>
                              </p>
                            ) : (
                              <p className="mob-slider-content text-right">
                                Android has the highest global
                                <div>market share, ensuring greater</div>
                                reach.
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-4 mob-two">
                          <div>
                            <h6 className="mob-slider-title text-left">
                              {isAndroidChange
                                ? "Scalability"
                                : "Cost Efficiency"}
                            </h6>
                            {isAndroidChange ? (
                              <p className="mob-slider-content text-left">
                                Android supports various devices,
                                <div>from smartphones to smart TVs.</div>
                              </p>
                            ) : (
                              <p className="mob-slider-content text-left">
                                Businesses can develop apps across
                                <div>a wide range of devices and</div>
                                price points.
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container mt-5">
                      <div className="row mob-slide-row">
                        <div className="col-sm-4 mob-three">
                          <div>
                            <h6 className="mob-slider-title text-right">
                              {isAndroidChange
                                ? "Open-Source Flexibility"
                                : "Multilingual Support"}
                            </h6>

                            {isAndroidChange ? (
                              <p className="mob-slider-content text-right">
                                Developers can experiment and
                                <div> innovate thanks to Android's </div>
                                open-source platform.
                              </p>
                            ) : (
                              <p className="mob-slider-content text-right">
                                Android supports multiple languages,
                                <div>
                                  {" "}
                                  making it ideal for global audiences.
                                </div>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-4 mob-four">
                          <div>
                            {isAndroidChange ? (
                              <h6 className="mob-slider-title text-left">
                                Integration with <div>Google Services</div>
                              </h6>
                            ) : (
                              ""
                            )}
                            {/* <h6 className="mob-slider-title text-left">
                              {isAndroidChange
                                ? "Integration with  Apple Ecosystem"
                                : ""}
                            </h6> */}
                            {isAndroidChange ? (
                              <p className="mob-slider-content text-left">
                                iOS apps work flawlessly with{" "}
                                <div> other Apple products like iCloud, </div>{" "}
                                Siri, and HomeKit.
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      {isAndroidChange ? (
                        <img
                          src={require("../../../image/mobileapp/featuresNew.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="mob-bg"
                          onClick={handleAndroidChange}
                        />
                      ) : (
                        <img
                          src={require("../../../image/mobileapp/features-twoNew.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="mob-bg"
                          onClick={handleAndroidChange}
                        />
                      )}
                    </div>
                  </div>

                  {/* visible at mobile view */}
                  <div className="primary__landing-content-container mob-features-card">
                    {/* key features */}
                    <div>
                      <h4 className="mob_feature-card-title">
                        Key Features of Android App Development
                      </h4>
                      <div className="mob-flex">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Customizable Interface
                              </h6>
                              <p className="mob-inner-slider-content">
                                Android apps allow greater flexibility in UI/UX
                                design.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Scalability
                              </h6>
                              <p className="mob-inner-slider-content">
                                Android supports various devices, from
                                smartphones to smart TVs.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mob-flex mob-flex-mt">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Open-Source Flexibility
                              </h6>
                              <p className="mob-inner-slider-content">
                                Developers can experiment and innovate thanks to
                                Android's open-source platform.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Integration with Google Services
                              </h6>
                              <p className="mob-inner-slider-content">
                                Android apps work seamlessly with Google Maps,
                                Gmail, and other Google tools.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* benefits */}
                    <div className="mt-5 pb-5">
                      <h4 className="mob_feature-card-title">
                        Benefits of Android App Development for Businesses
                      </h4>
                      <div className="mob-flex">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Larger Audience
                              </h6>
                              <p className="mob-inner-slider-content">
                                Android has the highest global market share,
                                ensuring greater reach.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Cost Efficiency
                              </h6>
                              <p className="mob-inner-slider-content">
                                Businesses can develop apps across a wide range
                                of devices and price points.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mob-flex mob-flex-mt">
                        <div className="w-100">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Multilingual Support
                              </h6>
                              <p className="mob-inner-slider-content">
                                Android supports multiple languages, making it
                                ideal for global audiences.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div>
                  <h2 className="mobile-sub-titles ios-title">
                    <span className="mobile-gradient ">
                      Progressive Web App (PWA)
                    </span>{" "}
                    Development: The Future of Mobile Apps
                  </h2>

                  <p className="mobile-types-content ios-content">
                    Progressive Web Apps (PWAs) combine the best features of
                    websites and mobile apps, offering a seamless user
                    experience without requiring downloads. PWAs are accessible
                    through browsers but provide app-like functionality, making
                    them a cost-effective solution for businesses.
                  </p>

                  {/* hide at mobile view */}
                  <h4 className="ios-key">
                    {isPWAChange
                      ? "Key Features of PWA Development"
                      : "Benefits of PWAs for Businesses"}
                  </h4>
                  <div className="mob-features">
                    <div className="container">
                      <div className="row mob-slide-row">
                        <div className="col-sm-4 mob-one">
                          <div>
                            <h6 className="mob-slider-title text-right">
                              {isPWAChange
                                ? "Fast Loading Speed"
                                : "Cost-Effective"}
                            </h6>
                            {isPWAChange ? (
                              <p className="mob-slider-content text-right">
                                PWAs load quickly even{" "}
                                <div>on slow networks.</div>
                              </p>
                            ) : (
                              <p className="mob-slider-content text-right">
                                Users can access content
                                <div>without an internet connection.</div>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-4 mob-two">
                          <div>
                            <h6 className="mob-slider-title text-left">
                              {isPWAChange
                                ? "Offline Functionality"
                                : "Improved Engagement"}
                            </h6>
                            {isPWAChange ? (
                              <p className="mob-slider-content text-left">
                                Users can access content
                                <div>without an internet connection.</div>
                              </p>
                            ) : (
                              <p className="mob-slider-content text-left">
                                Push notifications and offline access
                                <div>enhance user retention.</div>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container mt-5">
                      <div className="row mob-slide-row">
                        <div className="col-sm-4 mob-three">
                          <div>
                            <h6 className="mob-slider-title text-right">
                              {isPWAChange
                                ? "Responsive Design"
                                : "Simplified Maintenance"}
                            </h6>

                            {isPWAChange ? (
                              <p className="mob-slider-content text-right">
                                PWAs adapt to different screen
                                <div> sizes and devices.</div>
                                open-source platform.
                              </p>
                            ) : (
                              <p className="mob-slider-content text-right">
                                PWAs require fewer updates
                                <div> compared to native apps.</div>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-4 mob-four">
                          <div>
                            {isPWAChange ? (
                              <h6 className="mob-slider-title text-left">
                                App-Like Interface
                              </h6>
                            ) : (
                              ""
                            )}
                            {/* <h6 className="mob-slider-title text-left">
                              {isPWAChange
                                ? "Integration with  Apple Ecosystem"
                                : ""}
                            </h6> */}
                            {isPWAChange ? (
                              <p className="mob-slider-content text-left">
                                They mimic the look and{" "}
                                <div> feel of native apps. </div>{" "}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      {isPWAChange ? (
                        <img
                          src={require("../../../image/mobileapp/featuresNew.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="mob-bg"
                          onClick={handlePWAcHANGE}
                        />
                      ) : (
                        <img
                          src={require("../../../image/mobileapp/features-twoNew.webp")}
                          alt="Mobile App Development Company"
                          loading="lazy"
                          className="mob-bg"
                          onClick={handlePWAcHANGE}
                        />
                      )}
                    </div>
                  </div>

                  {/* visible at mobile view */}
                  <div className="primary__landing-content-container mob-features-card">
                    {/* key features */}
                    <div>
                      <h4 className="mob_feature-card-title">
                        Key Features of PWA Development
                      </h4>
                      <div className="mob-flex">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Fast Loading Speed
                              </h6>
                              <p className="mob-inner-slider-content">
                                PWAs load quickly even on slow networks.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Offline Functionality
                              </h6>
                              <p className="mob-inner-slider-content">
                                Users can access content without an internet
                                connection.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mob-flex mob-flex-mt">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Responsive Design
                              </h6>
                              <p className="mob-inner-slider-content">
                                PWAs adapt to different screen sizes and
                                devices.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                App-Like Interface
                              </h6>
                              <p className="mob-inner-slider-content">
                                They mimic the look and feel of native apps.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mob-flex mob-flex-mt">
                        <div className="w-100">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Cross-Platform Compatibility
                              </h6>
                              <p className="mob-inner-slider-content">
                                PWAs work on all devices with a web browser.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* benefits */}
                    <div className="mt-5 pb-5">
                      <h4 className="mob_feature-card-title">
                        Benefits of PWAs for Businesses
                      </h4>
                      <div className="mob-flex">
                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Cost-Effective
                              </h6>
                              <p className="mob-inner-slider-content">
                                PWAs eliminate the need for separate apps for
                                iOS and Android.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="mob-w-50">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Improved Engagement
                              </h6>
                              <p className="mob-inner-slider-content">
                                Push notifications and offline access enhance
                                user retention.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mob-flex mob-flex-mt">
                        <div className="w-100">
                          <div className="mob-feature-inner">
                            <div className="mob-feature-content-wrap">
                              <h6 className="mob-inner-slider-title">
                                Simplified Maintenance
                              </h6>
                              <p className="mob-inner-slider-content">
                                PWAs require fewer updates compared to native
                                apps.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <button
              className={`mob-prev-arrow ${isPrevDisabled ? "disabled" : ""}`}
              style={{
                color: isPrevDisabled ? "#fff" : "#fff",
                cursor: isPrevDisabled ? "not-allowed" : "pointer",
                background: isPrevDisabled ? "#808085" : "#808085",
              }}
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button
              className={`mob-next-arrow ${isNextDisabled ? "disabled" : ""}`}
              style={{
                color: isNextDisabled ? "#fff" : "#fff",
                cursor: isNextDisabled ? "not-allowed" : "pointer",
                background: isNextDisabled ? "#808085" : "#808085",
              }}
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </article>

        {/* why choose */}
        <article className="primary__landing-content-container mobile-why-choose">
          <h2 className="mobile-sub-titles mob-why-choose">
            <span className="mobile-gradient">Why Choose</span> a Mobile App
            Development Company?
          </h2>
          <p className="mobile-types-content ios-content">
            Partnering with a reliable mobile app development company can{" "}
            <div className="choose-inline">bring multiple advantages:</div>
          </p>

          <div className="row mob-choose-row">
            <div className="col-lg-3">
              <div className="mob-choose-cards">
                <div className="mob-inner">
                  <div className="mob-inner-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/expertise.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <h6 className="mob-inner-title">Expertise and Innovation</h6>
                  <p className="mob-inner-content">
                    Developers have the technical expertise to craft
                    user-friendly and secure apps.
                  </p>
                  <div className="inner-grad"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="mob-choose-cards">
                <div className="mob-inner">
                  <div className="mob-inner-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/custom.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <h6 className="mob-inner-title">Customization</h6>
                  <p className="mob-inner-content">
                    Solutions are tailored to your specific business goals and
                    audience.
                  </p>
                  <div className="inner-grad"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="mob-choose-cards">
                <div className="mob-inner">
                  <div className="mob-inner-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/cost.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <h6 className="mob-inner-title">
                    Cost-Effective Development
                  </h6>
                  <p className="mob-inner-content">
                    They optimize resources to ensure high-quality results
                    within your budget.
                  </p>
                  <div className="inner-grad"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="mob-choose-cards">
                <div className="mob-inner">
                  <div className="mob-inner-img-wrap">
                    <img
                      src={require("../../../image/mobileapp/post.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </div>
                  <h6 className="mob-inner-title">Post-Launch Support</h6>
                  <p className="mob-inner-content">
                    Continuous maintenance and updates keep your app relevant.
                  </p>
                  <div className="inner-grad"></div>
                </div>
              </div>
            </div>
          </div>

          <p className="mobile-types-content choose-card-content">
            When selecting a mobile app development company, look for their
            expertise{" "}
            <div className="choose-card-inline">
              in various app types, platforms, and the ability to innovate in
              the rapidly
            </div>
            evolving tech landscape.
          </p>
          <div className="text-center">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="mobile-app-btn"
            >
              Get Consultation{" "}
              <span className="mobile-btn-arr">
                <i className="fa-solid fa-chevron-right"></i>
              </span>
            </button>
          </div>
          {/* <img src={require("../../../image/mobileapp/features.webp")} alt="Mobile App Development Company" loading="lazy" /> */}
        </article>

        {/* company creates */}
        <article className="mobile-creates">
          <div className="primary__landing-content-container mobile-creates-inner">
            <h2 className="mobile-sub-titles creates-title">
              How a Mobile App Development{" "}
              <span className="mobile-gradient">Company Creates</span> Apps
            </h2>
            <p className="mobile-types-content creates-content">
              An experienced mobile app development company ensures the{" "}
              <div className="choose-inline">
                following steps for Android app development
              </div>
            </p>

            <div className="process-wrap">
              <div className="process-cards">
                <div className="process-card-flex">
                  <h5 className="process-num">01</h5>
                  <div>
                    <h6 className="process-card-title">Conceptualization</h6>
                    <p className="process-card-content">
                      Turning your business idea into a clear app strategy.
                    </p>
                  </div>
                </div>
                <div className="process-arrow-wrap">
                  <span className="process-arrow-span">
                    <i className="fa-solid fa-arrow-right"></i>
                    <img
                      src={require("../../../image/mobileapp/concept.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
              </div>
              <div className="process-cards process-borders">
                <div className="process-card-flex">
                  <h5 className="process-num">02</h5>
                  <div>
                    <h6 className="process-card-title">
                      Design and Prototyping
                    </h6>
                    <p className="process-card-content">
                      Developing attractive designs that appeal to app users.
                    </p>
                  </div>
                </div>
                <div className="process-arrow-wrap">
                  <span className="process-arrow-span">
                    <i className="fa-solid fa-arrow-right"></i>
                    <img
                      src={require("../../../image/mobileapp/design.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
              </div>
              <div className="process-cards process-borders">
                <div className="process-card-flex">
                  <h5 className="process-num">03</h5>
                  <div>
                    <h6 className="process-card-title">Development</h6>
                    <p className="process-card-content">
                      Developing apps with Java or Kotlin and frameworks.
                    </p>
                  </div>
                </div>
                <div className="process-arrow-wrap">
                  <span className="process-arrow-span">
                    <i className="fa-solid fa-arrow-right"></i>
                    <img
                      src={require("../../../image/mobileapp/develop.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
              </div>
              <div className="process-cards process-borders">
                <div className="process-card-flex">
                  <h5 className="process-num">04</h5>
                  <div>
                    <h6 className="process-card-title">Testing</h6>
                    <p className="process-card-content">
                      Conducting extensive tests for compatibility and
                      performance.{" "}
                    </p>
                  </div>
                </div>
                <div className="process-arrow-wrap">
                  <span className="process-arrow-span">
                    <i className="fa-solid fa-arrow-right"></i>
                    <img
                      src={require("../../../image/mobileapp/testing.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
              </div>
              <div className="process-cards process-borders">
                <div className="process-card-flex">
                  <h5 className="process-num">05</h5>
                  <div>
                    <h6 className="process-card-title">Deployment</h6>
                    <p className="process-card-content">
                      Publishing the mobile app on the App store and Google Play
                      Store.{" "}
                    </p>
                  </div>
                </div>
                <div className="process-arrow-wrap">
                  <span className="process-arrow-span">
                    <i className="fa-solid fa-arrow-right"></i>
                    <img
                      src={require("../../../image/mobileapp/deploy.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
              </div>
              <div className="process-cards">
                <div className="process-card-flex">
                  <h5 className="process-num">06</h5>
                  <div>
                    <h6 className="process-card-title">Ongoing Support</h6>
                    <p className="process-card-content">
                      Ensuring the app evolves with user needs.{" "}
                    </p>
                  </div>
                </div>
                <div className="process-arrow-wrap">
                  <span className="process-arrow-span">
                    <i className="fa-solid fa-arrow-right"></i>
                    <img
                      src={require("../../../image/mobileapp/support.webp")}
                      alt="Mobile App Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <img
            src={require("../../../image/mobileapp/creates-top-grad.webp")}
            alt="Mobile App Development Company"
            loading="lazy"
            className="creates-top"
          />
          <img
            src={require("../../../image/mobileapp/creates-bottom-grad.webp")}
            alt="Mobile App Development Company"
            loading="lazy"
            className="creates-bottom"
          />
        </article>

        {/* how to choose */}
        <article className="primary__landing-content-container mobile-how-to-choose">
          <h2 className="mobile-sub-titles ios-title">
            How to <span className="mobile-gradient">Choose the Right </span>
            Mobile App Development Company
          </h2>

          <div className="row how-to-choose-row">
            <div className="col-lg-6 how_app_imgdiv">
              <img
                src={require("../../../image/mobileapp/how.webp")}
                alt="Mobile App Development Company"
                loading="lazy"
                className="mob_app_imge"
              />
            </div>
            <div className="col-lg-6">
              <div>
                <ul className="mobile-lists">
                  <li className="mobile-list-content">
                    Selecting a reliable mobile app development company is
                    crucial for turning your app idea into a reality. Look for
                    companies with proven expertise in iOS, Android, and PWA
                    development.
                  </li>
                  <li className="mobile-list-content">
                    Review their past projects to assess quality and innovation.
                    Read testimonials and case studies for insights into their
                    customer satisfaction.
                  </li>
                  <li className="mobile-list-content">
                    Ensure the team is responsive and transparent about the
                    development process. Check if they offer maintenance and
                    updates after deployment.
                  </li>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="mobile-app-btn"
                  >
                    Get Demo
                    <span className="mobile-btn-arr">
                      <i className="fa-solid fa-chevron-right"></i>
                    </span>
                  </button>
                </ul>
              </div>
            </div>
          </div>
        </article>

        {/* Take away */}
        <article className="primary__landing-content-container">
          <div className="mob-take-away">
            <div className="mob-take-inner">
              <h2 className="mobile-sub-titles text-center take-away-title">
                {" "}
                <span className="mobile-gradient">Take Away</span>{" "}
              </h2>
              <p className="mob-take-content">
                A mobile app development company is your partner in creating
                applications that enhance user experience, drive engagement, and
                boost business growth. Whether you need a cutting-edge iOS app,
                a scalable Android application, or an innovative PWA, a trusted
                mobile app development company ensures success at every stage.
                By using advanced technologies and industry expertise, a mobile
                app development company delivers solutions that meet modern user
                demands and keep your business ahead of the competition.
              </p>
              <div className="text-center">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="mobile-app-btn"
                >
                  Get Consultation{" "}
                  <span className="mobile-btn-arr">
                    <i className="fa-solid fa-chevron-right"></i>
                  </span>
                </button>
              </div>
            </div>
            <img
              src={require("../../../image/mobileapp/mob-take-top.webp")}
              alt="Mobile App Development Company"
              loading="lazy"
              className="mob-take-top"
            />
            <img
              src={require("../../../image/mobileapp/mob-take-bottom.webp")}
              alt="Mobile App Development Company"
              loading="lazy"
              className="mob-take-bottom"
            />
          </div>
        </article>
      </main>

      {/* FAQ */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
                {/* <div className="landing-content-inline">
                  <span className="faq-span">Questions.</span>
                </div> */}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How do I choose the best mobile app development
                          company?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Look for a company with proven experience, a strong
                          portfolio, positive client reviews, and expertise in
                          the type of app you need (iOS, Android, or PWA).
                          Ensure they offer post-launch support and have clear
                          communication throughout the project.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          What is the difference between native apps and PWAs?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Native apps are built for specific platforms like iOS
                          or Android and must be downloaded from app stores.
                          PWAs, on the other hand, work through web browsers and
                          provide app-like functionality without requiring a
                          download.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          How long does it take to develop a mobile app?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The timeline depends on the app's complexity,
                          features, and platform. On average, simple apps take
                          2-3 months, while more advanced apps may take 3-6
                          months. A mobile app development company can provide
                          an accurate estimate after understanding your project
                          requirements.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default MobileApp;
